import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApizUIProcess, ProcessRequest, ProcessResponse } from '@compiere-ws/models/apiz-domains';
import { environment } from 'environments/environment';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompiereProcessService {
  private uiURL: string;
  private executionURL: string;

  constructor(private http: HttpClient) {}

  getProcess(processId: number): Observable<ApizUIProcess> {
    if (this.uiURL === undefined) {
      this.uiURL = environment.config.backend.ws.url + environment.config.backend.ws.paths['processUI'];
    }
    return this.http.get<ApizUIProcess>(`${this.uiURL}/${processId}`);
  }

  executeProcess(...params: ProcessRequest[]): Observable<ProcessResponse[]> {
    if (this.executionURL === undefined) {
      this.executionURL = environment.config.backend.ws.url + environment.config.backend.ws.paths['executeProcess'];
    }
    return this.http.post<ProcessResponse[]>(`${this.executionURL}`, params).pipe(
      tap((responses) => {
        const errors = responses.reduce(
          (_errors, response) => (response.error ? [..._errors, response.error] : _errors),
          [] as string[]
        );
        if (errors.length) {
          throw { error: errors.join(', ') };
        }
      })
    );
  }
}
